/**
 * Converts newline characters in a string to HTML <br> tags
 * @param str - The input string that may contain newline characters
 * @returns The string with newlines replaced by <br> tags
 */
export const newLineToBr = (str: string | undefined): string => {
  if (str === undefined) return '';
  return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
};

/**
 * Formats an EIN (Employer Identification Number) as `XX-XXXXXXX`.
 * Strips non-digits and caps at 9 digits, so it also works progressively as a
 * user types. Returns an empty string for empty input.
 * @param value - Raw or partially formatted EIN value
 */
export const formatEin = (value: string | null | undefined): string => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}-${digits.slice(2)}`;
};
